export const container = `
  text-ll-placeholder flex items-center gap-x-2 border border-ll-border h-10 px-5 rounded-full cursor-pointer transition-colors
  hover:bg-ll-placeholder hover:text-white 
  data-[active=true]:bg-ll-placeholder data-[active=true]:text-white 
`;

export const icon = `w-5 h-5`;

export const text = `text-sm font-medium leading-5 text-nowrap`;
